import React, { FC, useEffect, useState } from 'react';
import { CreateUser } from '../../components/CreateUser/CreateUser';
import axios from 'axios';
import { createUserRoute } from '../../lib/routes/persons';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import {
  getAwarenessSourceDictionary,
  getMaritalStatusDictionary,
  getRegionDictionary,
  getSubwayStationDictionary,
} from '../../store/slices/dictionariesSlice/dictionariesSlice';
import { checkIsLoaded } from '../../lib/utils/checkLoadingStatus';
import { message, Spin } from 'antd';
import CreateUserModal from '../../components/CreateUserModal/CreateUserModal';
import { toYearMonthDayLineFormat } from '../../lib/utils/formatDate';
import AuthService from '../../services/AuthService';
import LocalStorageService from '../../services/LocalStorageService';

const CreateUserContainer: FC = () => {
  const dispatch = useAppDispatch();
  const { maritalStatusLoading, regionLoading, subwayStationLoading, awarenessSourceLoading } = useAppSelector(
    (state) => state.dictionaries
  );
  const { properties } = useAppSelector((state) => state.root);
  const [createUserModalVisible, setCreateUserModalVisible] = useState(false);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (!checkIsLoaded(maritalStatusLoading, regionLoading, subwayStationLoading, awarenessSourceLoading)) {
      dispatch(getMaritalStatusDictionary());
      dispatch(getRegionDictionary());
      dispatch(getSubwayStationDictionary());
      dispatch(getAwarenessSourceDictionary());
    }
  }, [dispatch]);

  const createUser = (userData) => {
    const newUser = {
      password: userData.password,
      firstName: userData.firstName,
      lastName: userData.lastName,
      middleName: userData?.noMiddleName ? undefined : userData.middleName,
      maritalStatusId: userData?.maritalStatusId,
      birthDate: toYearMonthDayLineFormat(userData.birthDate),
      regionId: userData.regionId,
      email: userData?.email && String(userData.email).toLowerCase(),
      profession: userData?.profession,
      chronicDiseases: userData?.chronicDiseases,
      reason: userData?.volunteerReason,
      otherSource: userData?.otherSource,
      church: userData?.church,
      phone: userData?.phone,
      sourceId: userData?.awarenessSource,
      customSource: userData?.otherSource,
      address: {
        subwayStationId: userData?.subwayStationId,
        apartment: userData?.apartment,
        unstructuredAddress: userData.unstructuredAddress,
      },
      agreeDocuments: {
        document_terms_of_use: properties?.agree_documents?.terms_of_use,
        document_privacy_policy: properties?.agree_documents?.privacy_policy,
        document_personal_data: properties?.agree_documents?.personal_data,
      },
    };
    setLogin(newUser?.email);
    setPassword(newUser?.password);
    axios
      .post(createUserRoute(), newUser)
      .then(() => {
        setCreateUserModalVisible(true);
      })
      .catch((e) => {
        message.error(e?.response?.data?.message, 3);
      });
  };

  const handleModalOk = () => {
    AuthService.login(login, password)
      .then((response) => {
        LocalStorageService.setToken(response.data);
        LocalStorageService.setObject('isAuth', true);
        LocalStorageService.setObject('modalConfirmationEmailClosed', false);
        window.location.reload();
      })
      .catch((e) => {
        if (e.response.status === 400) {
          message.error('Неверные имя пользователя и/или пароль', 3);
        }
      });
    //window.location.replace('/login');
  };

  if (checkIsLoaded(maritalStatusLoading, regionLoading, subwayStationLoading)) {
    return (
      <>
        <CreateUserModal isOpened={createUserModalVisible} handleOk={handleModalOk} />
        <CreateUser createUser={createUser} />
      </>
    );
  }
  return <Spin />;
};

export default CreateUserContainer;
